import type { OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import type { FC } from "react"

import type { ApAgingVendor } from "../types/apAgingReport"

import { ApAgingInvoiceTable } from "./ApAgingInvoiceTable"

interface ApAgingVendorRowDetailsProps {
  row: Row<ApAgingVendor>
  invoiceSorting: SortingState
  onInvoiceSortingChange: OnChangeFn<SortingState>
}

export const ApAgingVendorRowDetails: FC<ApAgingVendorRowDetailsProps> = ({
  row,
  invoiceSorting,
  onInvoiceSortingChange,
}) => (
  <div className='m-4 overflow-hidden rounded border border-gray-300 bg-white'>
    <ApAgingInvoiceTable
      vendorCompanyId={row.original.vendorCompanyId}
      data={row.original.invoices}
      sorting={invoiceSorting}
      onSortingChange={onInvoiceSortingChange}
    />
  </div>
)
